import toast from "react-hot-toast";
import  {client} from "@/app/ApolloClient";
import {gql} from "@apollo/client";


var gqlSetAssetPublishedFlag = gql`
  mutation setAssetPublished($organizationId: UUID!,$assetId: UUID!, $published: Boolean!) {
    setAssetPublished(organizationId: $organizationId, assetId: $assetId, published: $published) 
  }  
`;

export function apiSetAssetPublished(organizationId, assetId, published) {

    return new Promise(async (resolve, reject) => {
        if(!organizationId) reject("organizationId is required");
        client
            .mutate({
                mutation: gqlSetAssetPublishedFlag,
                variables: {organizationId, assetId, published},
                errorPolicy: "ignore",
                fetchPolicy: "network-only"
            })
            .then((result) => {
                let data = result.data.setAssetPublished;
                console.log(data);
                if(data) resolve(data);
                else throw "Unable to set";
            })
            .catch((err) => {
                toast.error("Api Error, Unable to set published flag");
                reject(err);
            })
    });
}
